<div id="wrapper" class="app-container top-level-page" #appContainer
	 *ngIf="appLoaded">
    <header class="app-header bs-enabled">
        <div class="flex-row w-100 h-100">
			<div class="align-items-center" style="display: none; padding-left: 0.5rem; width: 50px;">
				<i class="mobile-hamburger far fa-bars text-white" style="font-size: 1.3rem;" (click)="toggleSidebarWidth();"></i>
			</div>
            <!--Global search-->
            <div class="f-1-0">
                <div class="global-search w-100">
                    <div class="search-box flex-row f-1-0">
                        <i class="zmdi zmdi-search"></i>
                        <input type="search" style="margin: 0; flex: 1 0;"
                               id="globalSearchInput"
                               (focus)="searchText ? (showGlobalSearchResults = true) : null"
                               (clickOutside)="showGlobalSearchResults = false;"
                               [exclude]="'#globalSearchResults'"
                               placeholder="Search anything..."
                               [(ngModel)]="searchText"
                               [maxlength]="dic.CONSTANTS.maxCharsInSearch"
                               (keyup)="searchGlobal(searchText)">
                        <a class="clear-x animated fadeIn"
                           *ngIf="searchText && searchText.length"
                           (click)="searchText = ''; searchResults = []; showGlobalSearchResults = false;">
                            <i class="zmdi zmdi-close"></i>
                        </a>
                    </div>
                    <div class="drop-menu flex-column" id="globalSearchResults"
                         [ngClass]="{'active' : showGlobalSearchResults}">
                        <ul (clickOutside)="showGlobalSearchResults = false;"
                            [exclude]="'#globalSearchInput'">
                            <li class="result"
                                *ngFor="let resultPageObj of searchResults | orderBy: 'rate'; trackBy: gs.trackByIndex"
                                (click)="navigateFromSearch(resultPageObj)">
                                <!--normal result-->
                                <a class="flex-row justify-content-between align-items-center"
                                   *ngIf="!resultPageObj.url">
                                    <div class="flex-row gap-2 align-items-baseline">
                                        <span class="fw-bold">{{resultPageObj.title}}</span>
                                        <span class="text-muted" style="font-size: 0.7rem;" *ngIf="resultPageObj.parentPage">/ {{resultPageObj.parentPage.title}}</span>
                                    </div>
                                    <span class="result-tag px-2 py-1">{{resultPageObj.tag || resultPageObj.parentSection.tag}}</span>
                                </a>
                                <!--external link result-->
                                <a class="flex-row justify-content-between align-items-center"
                                   *ngIf="resultPageObj.url"
                                   href="{{resultPageObj.url}}" target="_blank" rel="noopener noreferrer nofollow">
                                    <span class="fw-bold">{{resultPageObj.title}}</span>
                                    <i class="far fa-external-link-alt" style="position: relative; font-size: 0.8rem;"></i>
                                </a>
                            </li>
                        </ul>
                        <div class="f-1-0 w-100 flex-column centralize" *ngIf="!searchResults?.length">
                            <span>No results found</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-column align-items-center justify-content-center gap-1 app-page-title">
                <!--CC: section title removed - redundant with the page title and the sidebar active state; the tenant selector owns the header center-->
				<!-- CC: single-tenant admins get a static identity chip in the same spot - which environment am I acting on - no selector -->
				<div class="admin-select bs-enabled animated fadeIn"
					 *ngIf="gs.controlAdmin && !(gs.planAdmins?.length > 1 && userInfo?.show_multi_tenant && isMultiTenantSupported)">
					<div class="flex-row gap-2 align-items-center color-text" id="adminSelectLabel" style="cursor: default;">
						<i class="far fa-building opacity-75"></i>
						<span class="text-decoration-underline ellipsis">
							{{gs.controlAdmin.company_name || gs.controlAdmin.display_email}}
						</span>
					</div>
				</div>
				<!-- floating admin select dropdown-->
				<div class="admin-select bs-enabled animated fadeIn"
					 *ngIf="gs.planAdmins?.length > 1 && userInfo.show_multi_tenant && isMultiTenantSupported">
					<!-- CC: security reviewer only — prev/next around Managing (inbound-quarantined nav-arrow style, click-only) -->
					<div *ngIf="gs.reviewerInfo?.is_security_reviewer" class="flex-row align-items-center gap-2"
						 style="transition: transform 0.25s ease-out;">
						<button type="button" class="nav-arrow animated fadeIn"
								style="position: relative; top: auto; left: auto; transform: none; z-index: 1; flex-shrink: 0;"
								aria-label="Previous client"
								*ngIf="canNavigateClientPrev"
								(click)="navigateClient(-1, $event)">
							<i class="far fa-chevron-left"></i>
						</button>
						<div class="flex-row hvr-opacity gap-2 align-items-center color-text" id="adminSelectLabel"
							 [style.--bs-text-color]="lfs.textColor"
							 (click)="showAdminDropdown = !showAdminDropdown;">
							<span>Managing:</span>
							<span class="text-decoration-underline ellipsis">
								{{gs.controlAdmin.company_name || gs.controlAdmin.display_email}}
							</span>
							<span class="fw-light" *ngIf="userInfo && gs.controlAdmin && userInfo.email === gs.controlAdmin.email">&nbsp;(you)</span>
							<i class="far fa-chevron-down"></i>
							<i class="far fa-exclamation d-none"
							   *ngIf="userInfo && gs.controlAdmin && userInfo.email !== gs.controlAdmin.email"
							   tooltip="NOTE: You are managing another tenant" placement="bottom"></i>
						</div>
						<button type="button" class="nav-arrow animated fadeIn"
								style="position: relative; top: auto; right: auto; transform: none; z-index: 1; flex-shrink: 0;"
								aria-label="Next client"
								*ngIf="canNavigateClientNext"
								(click)="navigateClient(1, $event)">
							<i class="far fa-chevron-right"></i>
						</button>
					</div>
					<div *ngIf="!gs.reviewerInfo?.is_security_reviewer"
						 class="flex-row hvr-opacity gap-2 align-items-center color-text" id="adminSelectLabel"
						 [style.--bs-text-color]="lfs.textColor"
						 (click)="showAdminDropdown = !showAdminDropdown;">
						<span>Managing:</span>
						<span class="text-decoration-underline ellipsis">
							{{gs.controlAdmin.company_name || gs.controlAdmin.display_email}}
						</span>
						<span class="fw-light" *ngIf="userInfo && gs.controlAdmin && userInfo.email === gs.controlAdmin.email">&nbsp;(you)</span>
						<i class="far fa-chevron-down"></i>
						<i class="far fa-exclamation d-none"
						   *ngIf="userInfo && gs.controlAdmin && userInfo.email !== gs.controlAdmin.email"
						   tooltip="NOTE: You are managing another tenant" placement="bottom"></i>
					</div>
				</div>
            </div>

            <!--apply policy-->
            <div class="d-flex align-items-center" style="padding-left: 1rem;">
                <button type="button" class="bs-btn gap-2 border-rounded btn-in-header"
                        *ngIf="gs.showCopyPolicyBtn && (currentSection === dic.CONSTANTS.appStates.adminCenter ||
                        currentSection === dic.CONSTANTS.appStates.adminInbound || currentSection === dic.CONSTANTS.appStates.adminOutbound
                        || currentSection === dic.CONSTANTS.appStates.accountCompromised || currentSection === dic.CONSTANTS.appStates.domainProtection
                        || currentSection === dic.CONSTANTS.appStates.threatSimulation)"
                        (click)="installPolicyEl.installPolicy({ planAdmins: gs.planAdmins, controlAdmin: gs.controlAdmin })">
                    <span>Copy Policy</span>
					<i class="far fa-arrow-alt-circle-down"></i>
                </button>
            </div>

            <!--wizard/support/profile-->
            <div class="flex-row-reverse px-3 gap-4 f-1-0" style="margin-top: 5px;">
                <div class="flex-row gap-2 py-1 px-2 align-items-center profile-menu-container" id="profileMenuContainer">
                    <div class="flex-row align-items-center justify-content-center border-rounded overflow-hidden" style="width: 29.5px; height: 29.5px;" >
                        <i class="far fa-spin fa-spinner white-text" *ngIf="!userInfo?.picture"></i>
                        <img class="animated fadeIn" *ngIf="userInfo?.picture" [src]="userInfo.picture">
                    </div>
                    <div class="drop-menu">
                        <ul>
                            <li class="flex-column gap-1 static-menu-item">
                                <span class="fw-bold" style="word-break: break-word;">{{userInfo?.name}}</span>
                            </li>
                            <hr class="mt-0"/>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_accountSettings" *ngIf="showPersonalPages"
								[routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.accountDetailsPages.myAccount]">
                                <i class="far fa-cog"></i>
                                <span>Account Settings</span>
                            </li>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_myPlan" *ngIf="showPersonalPages"
								[routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.accountDetailsPages.myPlan]">
                                <i class="far fa-wallet"></i>
                                <span>My Plan</span>
                            </li>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_notifications" *ngIf="showPersonalPages"
								[routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.accountDetailsPages.notifications]">
                                <i class="far fa-bell"></i>
                                <span>Notifications</span>
                            </li>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_tickets" *ngIf="gs.showSupportMenu"
								[routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]">
                                <i class="far fa-ticket-alt"></i>
                                <span>Tickets</span>
                            </li>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_tools"
								[routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tools]">
                                <i class="far fa-tools"></i>
                                <span>Tools</span>
                            </li>
                            <hr/>
                            <li class="flex-row gap-2 align-items-center" id="profileMenu_logout"
                                (click)="logout()">
                                <i class="far fa-sign-out-alt"></i>
                                <span>Log Out</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="flex-row-reverse gap-2 align-items-center" *ngIf="userInfo.type !== dic.CONSTANTS.userTypes.dlp">
					<button type="button" class="bs-btn gap-2 border-rounded btn-in-header d-flex centralize" id="darkModeToggleBtn"
							(click)="darkModeToggle()" tooltip="Dark mode" placement="bottom" >
						<i class="fa fa-adjust" style="font-size: 15px; transform: rotate(180deg);"></i>
					</button>

					<button type="button" class="bs-btn gap-2 border-rounded btn-in-header d-flex centralize"
							style="padding: 7px !important;"
							(click)="showOnboardingWizard = true;" tooltip="Onboarding Wizard" placement="bottom"
							*ngIf="gs.showOnBoardingWizardBtn && !(userInfo?.managed_plans_only && gs.controlAdmin?.email === userInfo?.email)">
						<i class="far fa-hat-wizard" style="font-size: 15px;"></i>
					</button>

                    <support-menu-component *ngIf="gs.showSupportMenu"
											[showOnboardingButton]="showOnboardingButton"
											(onOnboardingBtnClick)="showOnboardingWizard = true;">
					</support-menu-component>

					<div class="shinyFX-light" style="overflow: hidden; animation-duration: 3s">
						<button type="button" class="bs-btn gap-2 border-0 btn-in-header hvr-darken-light"
								(click)="gs.showAiAssistant = !gs.showAiAssistant;">
							<span>AI Assistant</span>
							<i class="fa fa-magic"></i>
						</button>
					</div>

                    <!--what's new notifier-->
                    <div class="mx-2 whats-new-notification-container flex-column centralize position-relative h-100 cursor-default"
                         *ngIf="gs.whatsNewAlert;"
                         (click)="userInfo.whats_new_alert = !userInfo.whats_new_alert;">
                        <i class="far fa-bullhorn cursor-pointer p-1 animated tada" style="font-size: 1.1rem; transform: rotate(-10deg); animation-iteration-count: infinite; animation-duration: 1.5s;"></i>
                        <div class="drop-menu p-0 active" style="height: 75px; width: 400px;"
                             (click)="$event.stopPropagation();">
                            <div class="p-2 h-100 flex-row align-items-center gap-3" style="gap: 9px !important;">
                                <div class="bg-success h-100" style="width: 5px;"></div>
                                <i class="far fa-sun text-success" style="font-size: 28px;"></i>
                                <div class="flex-column gap-2">
                                    <h6 class="m-0">New Update Alert!</h6>
                                    <span style="font-size: 0.83rem; font-weight: 500;">
                                        Check out the new features in the
                                        <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.knowledge, dic.CONSTANTS.supportPages.whatsNew]" (click)="gs.whatsNewAlert = false;">
                                            What's New
                                        </a>
                                        page.
                                    </span>
                                </div>
                                <div class="flex-column h-100 centralize">
                                    <i class="p-1 zmdi zmdi-close closeRed cursor-pointer" (click)="gs.whatsNewAlert = false;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!--content below header-->
    <div class="app-content-area flxRow" style="flex: 1 0;">

        <!--sidebar-->
        <div class="bs-enabled flxClmn gap-2 app-sidebar" [ngClass]="{'collapsed' : isSidebarCollapsed}" [exclude]="'.mobile-hamburger'"
			 (clickOutside)="window.matchMedia('(max-width: 991px)').matches && !isSidebarCollapsed && toggleSidebarWidth();">
            <!--logo-->
            <div class="flex-row centralize" id="appSidebarLogo" style="width: 220px;">
                <img [src]="lfs.logo"/>
            </div>
            <!--collapse/expand button-->
            <div class="app-sidebar-toggle d-flex centralize"
                 (click)="toggleSidebarWidth();">
                <i class="far fa-angle-double-right"></i>
            </div>
            <!---->
            <!--navigation-->
            <nav class="f-1-0">
                <ul style="font-size: 13px;">
                    <!--menuItem = section (1st level) , childPage = page (2nd level)-->
					<ng-container *ngFor="let menuItem of appPagesNaviData">
						<li class="flex-column sidebar-menu-item"
							*ngIf="menuItem.show && (menuItem.showInSidebar !== false)"
							[ngClass]="{'expanded' : activeItemTitle === menuItem.title,
									   'active' : currentSection === menuItem.state,
									   'no-sub-items' : !menuItem.pages}">
							<div class="w-100 flex-row justify-content-between align-items-center sidebar-menu-title"
								 (click)="activeItemTitle === menuItem.title ? (activeItemTitle = null) : (activeItemTitle = menuItem.title);
										   (!menuItem.pages) && navigateToPage(menuItem.state, menuItem.pages?.[0]?.page || null);">
								<div class="flex-row f-1-0" style="overflow: visible; width: 20px;">
									<i class="section-icon" [ngClass]="menuItem.iconClass" *ngIf="menuItem.iconClass"></i>
									<div class="section-icon image-icon" style="background: black;"
										 [ngStyle]="{'mask-image' : 'url(\'../../images/' + menuItem.iconSvgName + '\')', '-webkit-mask-image' : 'url(\'../../images/' + menuItem.iconSvgName + '\')'}"
										 *ngIf="menuItem.iconSvgName">
									</div>
									<span class="align-self-center sidebar-title-text">
										{{menuItem.title}}
									</span>
									<span *ngIf="menuItem.isNewFeature" class="new-page-btn align-self-center mx-1">New</span>
								</div>
								<i class="far fa-chevron-down" style="font-size: 7px; transform: scale(1.3,1) rotate(90deg);"
								   *ngIf="menuItem.pages"></i>
							</div>
							<div class="flex-column sidebar-submenu-container">
								<div class="sidebar-submenu-dropdown-title">
									<span>{{menuItem.title}}</span>
								</div>
								<ng-container *ngFor="let childPage of menuItem.pages">
									<a class="mx-2 sidebar-submenu-item d-flex"
									   style="align-items: center; justify-content: space-between;"
									   [ngClass]="{'active' : currentSection === childPage.state || (currentPage === childPage.page && currentSection === menuItem.state)}"
									   *ngIf="childPage.show"
									   (click)="navigateToPage(menuItem.state, childPage.page); $event.stopPropagation();">
										<span>{{childPage.title}}</span>
										<span *ngIf="childPage.isNewFeature" class="new-page-btn">New</span>
										<span *ngIf="childPage.isBetaFeature" class="new-page-btn">Beta</span>
									</a>
								</ng-container>
							</div>
						</li>
					</ng-container>
                </ul>
            </nav>
        </div>

        <main class="app-content-container f-1-0" id="main">
            <div class="flxClmn w100 f-1-0 main-view"
				 [ngClass]="{'full-width' : currentSection === dic.CONSTANTS.appStates.knowledge}"
				 [style.scrollbar-gutter]="gs.showAiAssistant ? '' : 'stable'"
				 [style.overflow-x]="gs.showAiAssistant ? 'auto' : ''">
				<router-outlet></router-outlet>
			</div>
			<div class="ai-assistant-container bs-enabled" *ngIf="gs.showAiAssistant"
				 [ngClass]="{'active' : gs.showAiAssistant}">
				<ai-assistant-chat style="display: contents"
								   [isActive]="gs.showAiAssistant"
								   (closeCb)="gs.showAiAssistant = false;"></ai-assistant-chat>
			</div>
        </main>
    </div>

	<multi-tenant-selection-c *ngIf="showAdminDropdown"
							  [planAdmins]="planAdmins"
							  (onAdminSelected)="changeControlAdmin($event); showAdminDropdown = false;"
							  (onClose)="showAdminDropdown = false;">
	</multi-tenant-selection-c>

	<onboarding-wizard-component *ngIf="showOnboardingWizard"
								 (closeCb)="showOnboardingWizard = false;">
	</onboarding-wizard-component>

    <apply-policy-component #installPolicyEl></apply-policy-component>

	<notification-toaster-component></notification-toaster-component>

</div>
